<template>
  <svg
    version="1.1"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="m4.9414 67.137c-13.941-12.199 4.6289-33.43 18.574-21.227l15.734 13.719 34.988-48.219c10.902-15.051 33.793 1.5312 22.887 16.582-13.445 18.527-30.48 45.246-44.887
                61.707-5.1289 5.8633-14.039 6.4531-19.902 1.3242l-27.398-23.891z" />
  </svg>
</template>
